// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"Radio_checkboxContainer__1LEwB","checkboxLabel":"Radio_checkboxLabel__2VZmI","box":"Radio_box__iBWId","checked":"Radio_checked__16lKf"};